import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
/** V6 field composition of the shared shadcn Select. */
export default function ChoiceSelect({label,value,onChange,options,disabled=false}:{label:string;value:string;onChange:(value:string)=>void;options:readonly {value:string;label:string;disabled?:boolean}[];disabled?:boolean}) {
 return <Select value={value} onValueChange={v=>{if(v!==null)onChange(v)}} disabled={disabled} items={options}>
  <SelectTrigger className="p1-select" aria-label={label}><SelectValue /></SelectTrigger>
  <SelectContent className="p1-select-menu">{options.map(o=><SelectItem key={o.value} value={o.value} disabled={o.disabled}>{o.label}</SelectItem>)}</SelectContent>
 </Select>;
}
